module.exports = __webpack_public_path__ + "img/promoespacio.8322de05.png";